var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRegulatorio = function SvgIconRegulatorio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 38 38",
    viewBox: "0 0 38 38",
    xmlSpace: "preserve"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9,
    cy: 14.1,
    fill: "#E9EAEB",
    rx: 11.9,
    ry: 12.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF3829",
    d: "M12.5 14.8c-2.2 0-9.3 2.1-9.3 4.9v6.4h18.6v-6.4c.1-2.7-7-4.9-9.3-4.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 26.1H2.6v-6.4c0-3.4 7.8-5.5 9.9-5.5 1.3 0 3.6.6 5.5 1.4l-.4 1c-2-.8-4.1-1.3-5.1-1.3-2.3 0-8.7 2.2-8.7 4.3l-.1 6.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.1 6.2c0-2.6-2.1-4.6-4.6-4.6-2.6 0-4.6 2.1-4.6 4.6v3.1c0 2.6 2.1 4.6 4.6 4.6 2.6 0 4.6-2.1 4.6-4.6V6.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5c-2.9 0-5.2-2.3-5.2-5.2V6.2C7.3 3.3 9.6 1 12.5 1s5.2 2.3 5.2 5.2v3.1c.1 2.8-2.4 5.2-5.2 5.2zm0-12.4c-2.3 0-4.1 1.8-4.1 4.1v3.1c0 2.2 1.8 4.1 4.1 4.1s4.1-1.8 4.1-4.1V6.2c0-2.3-1.8-4.1-4.1-4.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.4 28c0 3.5-5.4 6.9-7.7 8.3C20.3 35 15 31.5 15 28v-8.9s3.7-2.1 7.7-2.1c3.9 0 7.7 2.1 7.7 2.1V28z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAEB",
    d: "M22.8 17c3.9 0 7.7 2.1 7.7 2.1V28c0 3.5-5.4 6.9-7.7 8.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.8 36.9-.3-.2c-3-1.7-8-5.1-8-8.7v-9.2l.3-.2c.2-.1 3.9-2.2 8-2.2s8.1 2.1 8.3 2.2l.6.2v.3s-.4 3.5-.4 9.3h-.1c0 3.8-5.1 6.8-8 8.5h-.4zm-7.2-17.4V28c0 3.1 5.2 6.4 7.2 7.6 2-1.2 7.2-4.5 7.2-7.6v-8.5c-.9-.5-4-1.9-7.2-1.9-3.3 0-6.3 1.4-7.2 1.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC0C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 5.9h1.1v3.6h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 7.2H23v1.1h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 5.9h1.1v3.6h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 7.2H23v1.1h-3.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC0C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 11.9h1.1v3.6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 13.2h3.6v1.1h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 11.9h1.1v3.6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 13.2h3.6v1.1h-3.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC0C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 5.1h1.1v3.6H33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 6.4h3.6v1.1h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 5.1h1.1v3.6H33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 6.4h3.6v1.1h-3.6z"
  }))));
};
export default SvgIconRegulatorio;